const initTips = () => {
  if (localStorage.getItem("tipsImports")) {
    return JSON.parse(localStorage.getItem("tipsImports") as string);
  }

  localStorage.setItem("tipsImports", "{}");
  return {};
};

export default {
  tips: initTips(),
};
